import { Avatar } from "@dash/avatar";
import { Button } from "@dash/form";
import { SectionHeader } from "@dash/page";
import { SearchButton } from "@dash/search";
import { useTheme } from "@emotion/react";
import { useProfiles } from "@megarax/features";
import type { FC } from "react";
import { MdClose } from "react-icons/md";

import type { TicketDetailDto } from "@megaron/support-contracts";

type Props = {
  ticket: TicketDetailDto;
  isEditable: boolean;
  isAssigneesBusy: boolean;
  userEmail: string | undefined;
  isAssignee: boolean;
  onJoin: () => void;
  onRemoveAssignee: (email: string) => void;
  onOpenAssigneeDialog: () => void;
};

export const SupportTicketMetaAssigneesSection: FC<Props> = ({
  ticket,
  isEditable,
  isAssigneesBusy,
  userEmail,
  isAssignee,
  onJoin,
  onRemoveAssignee,
  onOpenAssigneeDialog,
}) => {
  const theme = useTheme();
  const { profile } = useProfiles();

  return (
    <>
      <SectionHeader
        isHr
        css={{ h2: { fontSize: "16px" } }}
        actions={
          isEditable &&
          !isAssignee &&
          userEmail && (
            <Button size="small" variant="outline" isLoading={isAssigneesBusy} onClick={onJoin}>
              Dołącz
            </Button>
          )
        }
      >
        Uczestnicy
      </SectionHeader>
      <div css={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div css={{ display: "flex", flexDirection: "column", padding: "0 8px", gap: "10px" }}>
          {ticket.assignees?.map((assignee) => {
            const userProfile = profile(assignee.email);
            const displayName = userProfile
              ? `${userProfile.firstName} ${userProfile.lastName}`
              : assignee.email;
            return (
              <div css={{ display: "flex", gap: "10px", alignItems: "center" }} key={assignee.email}>
                <Avatar src={userProfile?.profilePictureUrl ?? null} />
                <span css={{ fontSize: "14px", fontWeight: 400 }}>{displayName}</span>
                <button
                  type="button"
                  onClick={() => isEditable && onRemoveAssignee(assignee.email)}
                  disabled={!isEditable}
                  css={{
                    marginLeft: "auto",
                    padding: 4,
                    border: "none",
                    background: "none",
                    cursor: isEditable ? "pointer" : "not-allowed",
                    color: theme.colors.secondaryText,
                    opacity: isEditable ? 1 : 0.5,
                  }}
                >
                  <MdClose size={18} />
                </button>
              </div>
            );
          })}
        </div>
        <SearchButton
          variant="pale"
          onClick={() => isEditable && onOpenAssigneeDialog()}
          inputText="Przypisz użytkownika..."
          css={{ cursor: isEditable ? "pointer" : "not-allowed", opacity: isEditable ? 1 : 0.5 }}
        />
      </div>
    </>
  );
};
